














import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import KintaiPatternCardList from '@/components/pattern/organisms/KintaiPatternCardList.vue'

@Component({
  components: { TcwLayoutBasicTemplate, KintaiPatternCardList }
})
export default class KintaiPatternListPage extends Mixins(BasePage) {}
